import { Commitment } from "@solana/web3.js";

export const MAX_TRANSACTION_BUNDLE_SIZE = 4; // max bundle size is 5 excluding tip txn

export const TRANSACTION_DEFAULT_BATCH_COMMITMENT: Commitment = "confirmed";
